import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getLevels = createAsyncThunk(
  "levels/getLevels",
  async (_, thunkApi) => {
    try {
      const { data } = await axiosInstance.get("/levels");
      // const filteredLevels = data.data.filter(
      //   (level) => level.icon !== null
      // );
      return thunkApi.fulfillWithValue({
        ...data,
        // data: filteredLevels.sort((a, b) => a.level - b.level),
      });
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getLevelById = createAsyncThunk(
  "levels/getLevelById",
  async (levelId, thunkApi) => {
    try {
      const { data } = await axiosInstance.get("/levels");
      const filteredLevel = data.data.filter(
        (level) => level._id === levelId
      );
      return thunkApi.fulfillWithValue({
        ...filteredLevel[0],
        // data: filteredLevels.sort((a, b) => a.level - b.level),
      });
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateLevel = createAsyncThunk(
  "levels/updateLevel",
  async (args, thunkApi) => {
    try {
      const { _id, formData } = args;
      const { data } = await axiosInstance.put(
        `/levels/${_id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const levelsSlice = createSlice({
  name: "levels",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getLevels.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLevels.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data;
        state.itemsCount = payload.data?.length;
        state.pages = 1;
        state.error = null;
      })
      .addCase(getLevels.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
      .addCase(getLevelById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLevelById.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = [payload];
        state.itemsCount = 1;
        state.pages = 1;
        state.error = null;
      })
      .addCase(getLevelById.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateLevel.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateLevel.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateLevel.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default levelsSlice.reducer;
